import { select } from "d3";

export default class Tooltip {
  constructor(id, offsetX = 30, offsetY = -40, duration = 100) {
    this.id = id;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    this.duration = duration;
  }

  show(e, info) {
    this.edit(info);
    this.move(e);
    select(`#${this.id}`)
      .style("display", "inline")
      .transition()
      .duration(this.duration)
      .style("opacity", 1.0);
  }

  hide() {
    select(`#${this.id}`)
      .transition()
      .duration(this.duration)
      .style("opacity", 0.0);
    this.edit("");
  }

  move(e) {
    if (!e) return;
    let { pageX: x, pageY: y } = e;
    x += this.offsetX;
    y = y + this.offsetY < 0 ? 10 : y + this.offsetY;
    select(`#${this.id}`).style("left", `${x}px`).style("top", `${y}px`);
  }

  edit(info) {
    select(`#${this.id}`).html(info);
  }
}
